<template>
  <multiselect
    ref="multiselect"
    v-bind="{ ...$attrs, ...context.attributes }"
    :tabindex="Number(-1)"
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
    :options="computedOptions"
    :optionHeight="40"
    :maxHeight="160"
    :placeholder="placeholder"
    :value="computedValue"
    :taggable="true"
    :custom-label="customLabel"
    :track-by="trackBy"
    :tag-placeholder="tagPlaceholder"
    :internal-search="false"
    @search-change="handleSearch"
    @open="handleOpen"
    @close="handleClose"
    @input="handleInput"
    @tag="handleAddTag"
  >
    <!-- Custom dropdown toggle -->
    <template #caret="{ toggle }">
      <div class="mc-caret__icon" @mousedown.prevent.stop="toggle" />
    </template>

    <template #selection="{ isOpen }">
      <i v-if="isOpen" class="mc-fa icon-fill_search me-1"></i>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
    },
    trackBy: {
      type: String,
      default: 'value',
    },
    tagPlaceholder: {
      type: String,
      default: 'Tambahkan data baru',
    },
    optionLabelFn: {
      type: Function,
      default: ({ item }) => item,
    },
  },
  emits: ['input', 'open', 'addTag'],
  data() {
    return {
      isOpenDropdown: false,
      filteredOptions: [],
    }
  },
  computed: {
    optionsContainerRef() {
      return this.$refs?.multiselect?.$refs?.list
    },
    computedValue() {
      if (this.context.model === '') {
        return undefined
      }
      
      return {
        label: this.context.model,
        value: this.context.model,
      }
    },
    computedOptions: {
      get() {
        return this.filteredOptions
      },
      set(value) {
        this.filteredOptions = value
      }
    }
  },
  watch: {
    'context.options': function(value) {
      this.computedOptions = value
    }
  },
  mounted() {
    document.addEventListener('scroll', this.repositionDropDown, true)
  },
  destroyed() {
    document.removeEventListener('scroll', this.repositionDropDown, true)
  },
  methods: {
    async handleOpen() {
      this.repositionDropDown()
      this.$emit('open')

      await this.$nextTick()
      this.isOpenDropdown = true
    },

    handleClose() {
      this.isLoading = false
      this.isOpenDropdown = false
      this.context.blurHandler()
    },

    handleInput(event) {
      let value
      
      if (event === null) {
        value = null
      } else {
        value = event.value
      }

      this.context.rootEmit('input', value)
    },

    handleAddTag(event) {
      this.context.rootEmit('input', event)
      this.context.rootEmit('addTag', event)
    },

    handleSearch(event) {
      this.computedOptions = this.context.options

      if (event) {
        this.computedOptions = this.context.options.filter(option => {
          return option.value.includes(event)
        })
      }
    },

    // Make dropdown display fixed to avoid being cut off by parent container
    // and make them stick to parent while scrolling
    repositionDropDown() {
      if (!this.optionsContainerRef?.style) return
      const { top, height, left } = this.$el.getBoundingClientRect()
      this.optionsContainerRef.style.width = `${this.$el.clientWidth}px`
      this.optionsContainerRef.style.position = 'fixed'
      this.optionsContainerRef.style.bottom = 'auto'
      this.optionsContainerRef.style.top = `${top + height}px`
      this.optionsContainerRef.style.left = `${left}px`
    },

    customLabel(item) {
      if (!this.optionLabelFn) return item

      return this.optionLabelFn({ item, options: this.options })
    },
  },
}
</script>
